// import addNuclein from '../components/nuclein/addNuclein.vue'
// import nucleinList from '../components/nuclein/nucleinList.vue'

export default [
    {
        path: 'nuclein/nucleinList',
        component: resolve => require(['@/components/nuclein/nucleinList'],resolve),
        name:"NucleinList",
        meta:{
            // id:'501',
            node:'nuclein',
            url:'nucleinList',
        }
    },
    {
        path: 'nuclein/addNuclein',
        component: resolve => require(['@/components/nuclein/addNuclein'],resolve),
        name:"AddNuclein",
        meta:{
            // id:'502',
            node:'nuclein',
            url:'addNuclein',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/nuclein.js